module.exports = __webpack_public_path__ + "static/media/120x600.c4e0c1f3.png";